import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";

import { Link, useNavigate, useParams } from "react-router-dom";

import { useWorkspaces } from "contexts/WorkspacesContext";
import { useGetProjectQuery } from "api/project/queries/useGetProjectQuery";
import { Icon } from "@iconify/react";
import { useGetScanQuery } from "api/scan/queries/useGetScanQuery";
import { truncateText } from "utils/misc";

const PCLDViewerHeader = ({ viewerName }: { viewerName?: string }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { projectSlug = "", scanId = "", workspaceSlug } = useParams();
  console.log("scanID", scanId);
  const { activeWorkspace } = useWorkspaces();
  const {
    data: project,
    isLoading: isProjectLoading,
    error: projectError,
  } = useGetProjectQuery(projectSlug, workspaceSlug);
  const {
    data: scan,
    isLoading: isScanLoading,
    error: scanError,
  } = useGetScanQuery(scanId || "");

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLaptop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      sx={{
        marginBottom: "1rem",
      }}
    >
      <Stack spacing={1}>
        <Stack direction={"row"} alignItems={"center"} flexWrap={"wrap"}>
          <Link to="../../.." relative="path">
            <Typography
              variant={isMobile ? "h4" : "h3"}
              sx={{
                color: "#fff8",
                fontWeight: "600",
                transition: "all .5s ease",
                ":hover": {
                  color: "white"
                }
              }}
            >{isLaptop ? activeWorkspace.name : truncateText(activeWorkspace.name, isMobile ? 10 : 20)}
            </Typography>
          </Link>
          <Icon icon={"icon-park-outline:right"} color="#aaa" />
          <Link to="../.." relative="path">
            <Typography
              variant={isMobile ? "h4" : "h3"}
              sx={{
                color: "#fff8",
                fontWeight: "600",
                transition: "all .5s ease",
                ":hover": {
                  color: "white"
                }
              }}
            >{isLaptop ? project?.name : truncateText(project?.name || "", isMobile ? 10 : 20)}
            </Typography>
          </Link>
          <Icon icon={"icon-park-outline:right"} color="#aaa" />
          <Link to=".." relative="path">
            <Typography
              variant={isMobile ? "h4" : "h3"}
              sx={{
                color: "#fff8",
                fontWeight: "600",
                transition: "all .5s ease",
                ":hover": {
                  color: "white"
                }
              }}
            >{scan && (isLaptop ? scan.description : truncateText(scan.description || "", isMobile ? 10 : 20))}
            </Typography>
          </Link>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip title="Back" placement="right">
            <IconButton
              onClick={async () => {
                navigate("..", { relative: "path" });
              }}
            >
              <ArrowBackIcon sx={{ fontSize: "1.25rem" }} />
            </IconButton>
          </Tooltip>
          <Typography variant={isMobile ? "h2" : "h1"} sx={{ fontWeight: "600" }}>{viewerName ? viewerName : "Point Cloud Viewer"}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PCLDViewerHeader;
